import {atom} from "recoil";
import keys from "configs/atoms";

const lookupStatsDatesAtom = atom(({
    key: keys.Lookup.StatDates,
    default: []//lookupStatsDatesSelector
}));

export default lookupStatsDatesAtom;